module.exports = __webpack_public_path__ + "static/no-future-without-forgiveness-61c25e2d20fd44c88d8ee3247205afac.jpg";